// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2wNh2","colCheckbox":"styles_colCheckbox__3fxoQ"};